export class UnsupportedNetworkError extends Error {
    constructor(chainIdOrName) {
      let errMsg = chainIdOrName ? ` (${chainIdOrName})` : "";

      super(`Unsupported network chain ID or name${errMsg}`);
      this.name = "UnsupportedNetworkError";
    }
  }  